const ENTITY_VIEWS = {
  "List View": 1,
  "Tile View": 2,
  "ER Diagram": 3,
  Mapping: 4,
};

const groupTypes = [
  { id: "eq", label: "Exact" },
  { id: "jw", label: "Jaro-Winkler" },
  { id: "isn", label: "IsNull" },
];

const ruleTypes = [
  { id: "auto", label: "Auto-Merge" },
  { id: "suspect", label: "Suspect Match" },
];

const ruleGroupRowHeader = {
  eq: "Exact",
  jw: "Fuzzy",
  isn: "IsNull",
};

const TAG_COLUMN_PREFIX = "tag_";

export { groupTypes, ruleGroupRowHeader, ruleTypes, ENTITY_VIEWS, TAG_COLUMN_PREFIX };
